import React from 'react';
import LandingPagePhotoToPDFModal from 'LandingPagePhotoToPDFModal';
import EditPDFLandingPageRadioButtons from './EditPDFLandingPageRadioButtons';

const EditPDFLandingPageSmallUploadPanel = () => (
  <div className="span6">
    <div className="upload-wrap edit-pages-upload-wrap hide-for-photos">
      <div
        className="uploader-title edit-pages-uploader-title"
      >
        Let’s get started!
      </div>
      <EditPDFLandingPageRadioButtons />
      <form id="dropzoneUploader" className="uploader">
        <div className="alert alert-error uploader-error">Error</div>
        <a
          id="uploadPDFLargeMobile"
          className="btn btn-custom_info is-block is-big is-hidden"
        >
           Select a file to Upload
        </a>
        <div
          className="uploader-area edit-pages-uploader-area"
          onDrop={window._track('Edit PDF Landing Page', 'Drag and Drop Upload Zone')}
        >
          <div className="uploader-subtitle">Drag and drop your file here</div>
          <img src="/images/icon-drag&drop.png" alt="" />
          <div className="uploader-devider">or</div>
          <a
            id="uploadPDFLarge"
            className="btn btn-custom_info is-block is-big"
          >
            Select a file to Upload
          </a>
        </div>
      </form>
    </div>
    <LandingPagePhotoToPDFModal />
  </div>
);

export default EditPDFLandingPageSmallUploadPanel;



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageSmallUploadPanel.jsx